import { FaqItem } from '../types';

export const FAQS: FaqItem[] = [
  {
    id: '1',
    question: 'Erkek lazer epilasyon acıtır mı? Ağrı hisseder miyim?',
    answer: 'Nilüfer FSM Bulvarı kliniğimizde kullandığımız yeni nesil medikal safir soğutmalı buz lazer başlığı sayesinde acı hissi minimuma indirgenmiştir. İşlem anında cilt yüzeyi -5°C soğutulduğundan çoğu danışanımız sadece hafif bir ferahlık veya sinek ısırığı gibi çok hafif bir his tarif etmektedir.',
    category: 'islem'
  },
  {
    id: '2',
    question: 'Bursa erkek lazer epilasyon fiyatları ne kadar? Neden sitede fiyat yazmıyor?',
    answer: 'Erkeklerde kıl yoğunluğu, cilt tonu, uygulama yapılacak bölge genişliği (örneğin sadece sakal üstü vs. sırt + omuz kombinasyonu) ve hedeflenen sonuç (tam bitirme veya doğal seyreltme) kişiden kişiye değişir. Yanıltıcı ve taban fiyatlar vermek yerine; WhatsApp hattımız üzerinden size özel, en avantajlı paket teklifini 2 dakika içinde hazırlayıp iletiyoruz.',
    category: 'fiyat'
  },
  {
    id: '3',
    question: 'Kaç seansta kesin sonuç alırım? Seans aralıkları ne kadardır?',
    answer: 'Erkeklerde kıl kökleri kadınlara göre daha derinde yerleştiği için ortalama 6 ila 8 seans arasında %85-95 oranında kalıcı dökülme sağlanır. Seans aralıkları başlangıçta 4-6 hafta olup, ilerleyen seanslarda 8 haftaya kadar uzar.',
    category: 'islem'
  },
  {
    id: '4',
    question: 'Doktor kliniğinde işlem yaptırmanın ne gibi avantajları vardır?',
    answer: 'Lazer epilasyon yüksek enerjili medikal bir uygulamadır. Bir hekim kontrolündeki klinik ortamında bulunmak; FDA onaylı orijinal cihaz kullanımı, hijyenik sterilizasyon, benlerinizin korunması, yanık ve leke riskinin sıfıra indirilmesi ve gizliliğin tam sağlanması açısından en yüksek güvencedir.',
    category: 'klinik'
  },
  {
    id: '5',
    question: 'Göğüs ve kol kıllarımı tamamen bitirmek istemiyorum, sadece seyreltebilir miyim?',
    answer: 'Evet! Erkek danışanlarımızın büyük çoğunluğu özellikle göğüs, kol ve bacak bölgelerinde kılların tamamen sıfırlanması yerine %60-70 oranında seyreltilerek doğal, estetik ve ferah bir görünüme kavuşmasını tercih etmektedir. Seans sayısını ve enerji seviyesini bu hedefe göre ayarlıyoruz.',
    category: 'islem'
  },
  {
    id: '6',
    question: 'Sakal üstü ve boyun lazeri batıklara ve tıraş tahrişine iyi gelir mi?',
    answer: 'Kesinlikle evet. Sakal üstü ve boyun bölgesinde her gün tıraş olmaktan kaynaklanan folikülit (kıl dönmesi) ve iltihaplı sivilceler, lazer epilasyon ile kıl kökleri devre dışı bırakıldığında kalıcı olarak tamamen son bulur.',
    category: 'genel'
  },
  {
    id: '7',
    question: 'Randevu nasıl alabilirim? FSM Bulvarı kliniğinize nasıl ulaşırım?',
    answer: 'WhatsApp hattımızdan veya web sitemizdeki hızlı randevu butonlarından dilediğiniz gün ve saat için ön görüşme talep edebilirsiniz. Kliniğimiz Bursa Nilüfer FSM Bulvarı üzerinde merkezi konumda yer almakta olup, FSM metro istasyonuna ve kapalı otopark alanlarına birkaç dakika yürüme mesafesindedir.',
    category: 'klinik'
  },
  {
    id: '8',
    question: 'Bursa erkek özel bölge lazer epilasyon işlemi güvenli midir? Kısırlık riski var mı?',
    answer: 'Kesinlikle %100 güvenlidir. Medikal lazer dalga boyları yalnızca cilt yüzeyinin 2-4 milimetre altındaki kıl kökünü (melanin pigmentini) hedefler; asla testisler, iç organlar veya üreme sistemi katmanlarına inemez. Radyasyon içermez, FDA onaylıdır ve kısırlıkla hiçbir tıbbi veya fizyolojik ilişkisi yoktur.',
    category: 'islem'
  },
  {
    id: '9',
    question: 'Erkek özel bölge (genital & kasık) seanslarında mahremiyet ve uzman seçimi nasıldır?',
    answer: 'Bursa Nilüfer FSM Bulvarı kliniğimizde mahremiyet en hassas prensibimizdir. Özel bölge seansları tamamen erkek danışanlarımıza ayrılmış steril odada, deneyimli erkek uzmanlarımız tarafından ve kişiye özel tek kullanımlık medikal hijyen kitleri kullanılarak gerçekleştirilir.',
    category: 'klinik'
  }
];

export const FEMALE_FAQS: FaqItem[] = [
  {
    id: 'f1',
    question: 'Genital ve bikini bölgesi lazer epilasyon güvenli midir? Yumurtalıklara zarar verir mi veya kısırlık yapar mı?',
    answer: 'Kesinlikle %100 güvenlidir ve kısırlık yapmaz. Medikal buz lazer ışınları cildin yalnızca 2 ila 4 milimetre altındaki kıl folikülünde yer alan melanin pigmentini hedefler. Işınlar rahim, yumurtalıklar veya lenf bezlerine asla ulaşamaz. İyonize olmayan (radyasyonsuz) ışık enerjisidir ve kadın sağlığı açısından FDA onaylı en güvenli yöntemdir.',
    category: 'islem'
  },
  {
    id: 'f2',
    question: 'Lazer epilasyon bacaklardaki batıkları ve çilek bacak (strawberry legs) görünümünü geçirir mi?',
    answer: 'Evet! Ağda ve jilet sonrası oluşan kıl dönmeleri, gözenek içi siyah noktalar ve iltihaplı batıklar (çilek bacak görünümü) kadınların en büyük problemidir. Lazer epilasyon kıl kökünü kalıcı olarak yok ettiği için 2. seanstan itibaren batıklar tamamen kaybolur ve bacak cildi pürüzsüz, ipeksi bir dokuya kavuşur.',
    category: 'genel'
  },
  {
    id: 'f3',
    question: 'Kadınlarda kaç seansta kesin sonuç alınır? Seans aralıkları ne kadardır?',
    answer: 'Kadın vücut bölgelerinde (Tüm bacak, koltuk altı, genital) ortalama 6 ila 8 seansta %85-95 oranında kalıcı pürüzsüzlük sağlanır. Yüz bölgesinde kıl döngüsü daha hızlı olduğu için 8-10 seans gerekebilir. Vücut seans aralıkları ilk aşamada 4-6 hafta, ilerleyen seanslarda ise 8 haftadır.',
    category: 'islem'
  },
  {
    id: 'f4',
    question: 'Yüz bölgesindeki (çene, bıyık, favori) ince tüyler lazerle çoğalır mı (tetiklenir mi)?',
    answer: 'Klasik Alexandrite cihazları yüzde uygulandığında ince ayva tüylerini tetikleyerek kalınlaştırabilir. Ancak kliniğimizde kullandığımız 3 dalga boylu Hibrit Buz Diode teknolojisi, ince tüyleri tetiklemeden güvenle hedef alır ve hekim kontrolünde güvenli parametrelerle uygulanır.',
    category: 'islem'
  },
  {
    id: 'f5',
    question: 'Seanslara kadın estetisyenler mi giriyor? Mahremiyet nasıl sağlanıyor?',
    answer: 'Bursa Nilüfer FSM Bulvarı kliniğimizde kadın danışanlarımızın tüm seansları (özellikle genital, bikini ve tüm vücut seansları) yalnızca alanında uzman, deneyimli kadın estetisyenlerimiz tarafından yürütülür. Odalarımızda kişiye özel tek kullanımlık steril medikal örtüler ve en yüksek mahremiyet standartları uygulanır.',
    category: 'klinik'
  },
  {
    id: 'f6',
    question: 'Buz lazer seansları acıtır mı? Hassas bölgelerde canım yanar mı?',
    answer: 'Kliniğimizdeki yeni nesil medikal cihaz, -5°C safir temaslı soğutma sistemine sahiptir. Atış anında cildi sürekli dondurarak sinir uçlarını duyarsızlaştırır. Klasik lazerlerdeki gibi sıcak lastik çarpması hissi yaşanmaz; genital ve koltuk altı gibi en hassas bölgelerde bile konforlu, masaj hissi veren ferah bir seans yaşarsınız.',
    category: 'islem'
  },
  {
    id: 'f7',
    question: 'Ağda, cımbız veya epilatör kullandıktan ne kadar sonra lazere başlayabilirim?',
    answer: 'Kıl kökünün lazer ışığını emebilmesi için kökün folikülde bulunması şarttır. Bu nedenle ağda, cımbız veya epilatör gibi kökten alan yöntemleri bıraktıktan en az 3-4 hafta sonra seanslara başlanmalıdır. Seans aralarında ise sadece jiletle kısaltma yapılmalıdır.',
    category: 'genel'
  },
  {
    id: 'f8',
    question: 'Bursa kadın lazer epilasyon paket fiyatları nasıl belirlenir?',
    answer: 'Fiyatlandırma seçtiğiniz bölgelere (Tüm Bacak + Genital + Koltuk Altı Altın 3’lü Paket, Tüm Vücut veya Tek Bölge) ve kıl yapınıza göre belirlenir. Kliniğimizde hekim kontrolünde ücretsiz kıl analizi yapılarak size en uygun avantajlı paket ve taksit imkanları sunulmaktadır.',
    category: 'fiyat'
  },
  {
    id: 'f9',
    question: 'Hamilelik veya emzirme döneminde lazer epilasyon yaptırabilir miyim?',
    answer: 'Hamilelik sürecinde değişen hormon dengesi ve etik tıbbi prensipler gereği seans önermiyoruz. Doğumdan ve lohusalık döneminden sonra (özellikle emzirme döneminde doktor onayı ile) hormonlar dengelendiğinde seanslarınıza güvenle devam edebilirsiniz.',
    category: 'klinik'
  }
];
